/** @typedef {'jyotisha' | 'numerology' | 'sadhana' | 'askBhrigu'} FeatureKey */

/** @typedef {Record<FeatureKey, boolean>} FeatureVisibilityMap */

export const FEATURE_KEYS = /** @type {const} */ ([
  'jyotisha',
  'numerology',
  'sadhana',
  'askBhrigu',
]);

/** @type {FeatureVisibilityMap} */
export const DEFAULT_FEATURE_VISIBILITY = {
  jyotisha: true,
  numerology: true,
  sadhana: true,
  askBhrigu: false,
};

/** Maps app page ids to a feature toggle key. */
export const PAGE_FEATURE_MAP = {
  jyotisha: 'jyotisha',
  'jyotish-marga': 'jyotisha',
  phaladeepika: 'jyotisha',
  bhagyank: 'numerology',
  sadhana: 'sadhana',
  'ask-guru': 'askBhrigu',
};

/** @param {unknown} raw */
export function normalizeFeatureVisibility(raw) {
  /** @type {FeatureVisibilityMap} */
  const out = { ...DEFAULT_FEATURE_VISIBILITY };
  if (!raw || typeof raw !== 'object') return out;
  for (const key of FEATURE_KEYS) {
    if (typeof raw[key] === 'boolean') out[key] = raw[key];
  }
  return out;
}

/** @param {string | null | undefined} pageId @param {FeatureVisibilityMap} visibility @param {boolean} [isAdmin] */
export function isPageVisibleForUser(pageId, visibility, isAdmin = false) {
  if (isAdmin) return true;
  const feature = PAGE_FEATURE_MAP[pageId];
  if (!feature) return true;
  return visibility[feature] ?? DEFAULT_FEATURE_VISIBILITY[feature];
}
